goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg.default;
